<p>
  <span>Version / Build:</span><span>{{ getVersion() }} / {{ getBuild() }} </span>
</p>
<p>
  <span>Commit:</span><span>{{ getGitHash() }}</span>
</p>
<p>
  <span>Timestamp:</span><span>{{ getTimestamp() }}</span>
</p>
